import React from "react";
import ReactDOM from "react-dom/client";
import "./css/normalize.css";
import "./css/toolv3.css";
import "./css/var.css";
import HttpsRedirect from "react-https-redirect";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

console.log("LT Mastery v2.4");

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <HttpsRedirect>
      <App />
    </HttpsRedirect>
  </BrowserRouter>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
